<template>
  <label class="input-search">
    <i class="icon icon-search input-search__icon" />
    <input
      v-model="search"
      type="text"
      :placeholder="placeholder"
      @input="throttledSave"
    />
  </label>
</template>

<script>
    import throttle from '../../utils/throttle'

    export default {
        name: 'InputSearch',
        props: {
          value: {
              type: String,
              default: '',
          },
            placeholder: {
              type: String,
              default() {
                return this.$t('filter.placehoder')
              },
            },
            delay: {
              type: [String, Boolean],
                default: false,
            },
        },
        data: () => ({
            search: '',
        }),
        computed: {
            throttledSave() {
                if (this.delay) {
                    return throttle(this.save, this.delay)
                }
                return this.save
            },
        },
        watch: {
            value(val) {
                this.search = val
            },
        },
        methods: {
            save() {
                this.$emit('input', this.search)
            },
        },
    }
</script>
